const VerseTranslate = [
  {
    identifier: "en.transliteration",
    langName: "الإنجليزية (تهجئة)",
    EnglishLangName: "English (transliteration)",
  },
  {
    identifier: "en.ahmedali",
    langName: "الإنجليزية",
    EnglishLangName: "English",
  },
  {
    identifier: "id.indonesian",
    langName: "الأندونيسية",
    EnglishLangName: "indonesian",
  },
  {
    identifier: "fr.hamidullah",
    langName: "الفرنسية",
    EnglishLangName: "French",
  },
  {
    identifier: "ru.kuliev",
    langName: "الروسية",
    EnglishLangName: "Russian",
  },
  {
    identifier: "zh.jian",
    langName: "الصينية",
    EnglishLangName: "Chinese",
  },
  {
    identifier: "es.cortes",
    langName: "الأسبانية",
    EnglishLangName: "Spanish",
  },
  {
    identifier: "ja.japanese",
    langName: "اليبانية",
    EnglishLangName: "Japanese",
  },
  {
    identifier: "hi.hindi",
    langName: "الهندية",
    EnglishLangName: "Hindi",
  },
  {
    identifier: "tr.ates",
    langName: "التركية",
    EnglishLangName: "Turkish",
  },
  {
    identifier: "ko.korean",
    langName: "الكورية",
    EnglishLangName: "korean",
  },
  {
    identifier: "bn.bengali",
    langName: "بنغلادش",
    EnglishLangName: "Bangladesh",
  },
];

export default VerseTranslate;
